import { GlobalCSS, ThemeProvider } from "@rescuetablet/theme";
import { SnackbarProvider } from "notistack";
import { Suspense } from "react";
import { MapProvider } from "react-map-gl";
import { Navigate, RouterProvider } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import GlobalLoading from "./GlobalLoading";
import Layout from "./Layout";
import MissionListPage from "./MissionListPage";
import MissionPage from "./MissionPage";
import MissionsProvider from "./MissionsProvider";
import PatientForm from "./PatientForm";
import PatientListPage from "./PatientListPage";
import { AuthProvider } from "./auth";

export default function App() {
  return (
    <ThemeProvider>
      <GlobalCSS />
      <SnackbarProvider>
        <Suspense fallback={<GlobalLoading />}>
          <AuthProvider>
            <MapProvider>
              <Layout>
                <Main />
              </Layout>
            </MapProvider>
          </AuthProvider>
        </Suspense>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <MissionsProvider />,
    children: [
      { index: true, element: <MissionListPage /> },
      {
        path: ":missionId",
        element: <MissionPage />,
        children: [
          {
            path: "patients",
            children: [
              { index: true, element: <PatientListPage /> },
              { path: ":patientId", element: <PatientForm /> },
            ],
          },
          { index: true, element: <Navigate to="patients" /> },
        ],
      },
    ],
  },
]);

function Main() {
  return <RouterProvider router={router} />;
}
